var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#70EC9D",
    d: "M50 100c27.615 0 50-22.385 50-50S77.615 0 50 0 0 22.385 0 50s22.385 50 50 50Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.126 61.161c.306-.305.72-.477 1.153-.477h39.904c.726 0 1.09.879.576 1.393l-7.885 7.878a1.63 1.63 0 0 1-1.153.478H25.817a.816.816 0 0 1-.576-1.393l7.885-7.879Zm0-29.434c.306-.305.72-.477 1.153-.477h39.904c.726 0 1.09.879.576 1.393l-7.885 7.878a1.63 1.63 0 0 1-1.153.478H25.817a.816.816 0 0 1-.576-1.393l7.885-7.879ZM66.874 46.35a1.631 1.631 0 0 0-1.153-.477H25.817a.816.816 0 0 0-.576 1.393l7.885 7.879c.306.305.72.477 1.153.477h39.904a.816.816 0 0 0 .576-1.393l-7.885-7.878Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.cd906247cc4d6e2321fe3f82251c5713.svg";
export { ForwardRef as ReactComponent };